/**
 * Automation Spotlight Lesson
 * Skill Area: Automation
 * Identify high-value automation opportunities
 */

import type { LessonDefinition } from '../types';
import { AUTOMATION_SPOTLIGHT_AI_PROMPT, AUTOMATION_SPOTLIGHT_CONTEXT_SCENARIOS } from '../prompts/automation-spotlight.prompt';

export const automationSpotlight: LessonDefinition = {
  id: 'automation-spotlight',
  title: 'Automation Spotlight',
  displayTitle: 'Identify High-Value Automation Opportunities',
  subTitle: 'Spot a repeat task worth automating.',
  persona: 'Lyra',
  skillArea: 'Automation',
  topicId: 'process-automation',
  topicTitle: 'Process Automation',
  topicDescription: 'Identify automation opportunities and design human-AI workflows.',
  format: 'scenario',
  difficulty: 'Intermediate',
  estimatedMinutes: 7,
  tags: ['ops', 'savings', 'systems'],
  dailyEligible: false,
  releasedAt: '2025-01-25T00:00:00.000Z',
  route: '/micro/automation-spotlight',
  storyBeat: 'Lyra keeps you from doing the same work twice.',
  contextTitle: "Great loops to test",
  contextSummary: "Pick a task you do over and over, or describe your own. Lyra will show what starts it, where AI can help, and where to double-check.",
  contextScenarios: AUTOMATION_SPOTLIGHT_CONTEXT_SCENARIOS,
  introPrompt: "Repetitive tasks are silent time thieves. I'll explain why automation is key, show you a manual vs. automated loop, and help you map one out.",
  steps: [
    "Identify a recurring task you dread",
    'See a "Manual Loop vs. Automated Loop" comparison',
    'Map your workflow with a human safety check'
  ],
  promptGuidance: 'Choose a task below or type your own.',
  aiPrompt: AUTOMATION_SPOTLIGHT_AI_PROMPT,
  inputPlaceholder: "Type 'Weekly Receipts' or your own task...",
  quickPrompts: [
    'Weekly Receipts',
    'Event Signups',
    'Onboarding Emails'
  ]
};
